import { Link } from "react-router-dom";
import { Mail, Phone, MessageCircle } from "lucide-react";
import VELogo from "./VELogo";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <Link
            to="/"
            className="flex items-center gap-2 font-heading font-semibold text-xl text-white"
          >
            <VELogo size={28} />
            Veer Electrical
          </Link>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">
            Your trusted source for premium electrical goods. Authorised
            distributor of leading brands across switches, lighting, fans, MCBs
            and cables.
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">
            Categories
          </p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/category/switches" className="hover:text-amber-400">Switches</Link></li>
            <li><Link to="/category/leds" className="hover:text-amber-400">LED Lights</Link></li>
            <li><Link to="/category/fans" className="hover:text-amber-400">Fans</Link></li>
            <li><Link to="/category/mcb" className="hover:text-amber-400">MCB &amp; Distribution</Link></li>
            <li><Link to="/category/wires" className="hover:text-amber-400">Wires &amp; Cables</Link></li>
            <li><Link to="/category/automation" className="hover:text-amber-400">Automation</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">
            Get in touch
          </p>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2">
              <MessageCircle className="w-4 h-4 text-amber-400" />
              <a
                href="https://wa.me/917400042543"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-amber-400"
                data-testid="footer-whatsapp"
              >
                WhatsApp: +91 74000 42543
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-amber-400" />
              <a href="tel:+917400042543" className="hover:text-amber-400">
                +91 74000 42543
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-amber-400" />
              <a
                href="mailto:inquiry@veerelectrical.com"
                className="hover:text-amber-400"
                data-testid="footer-email"
              >
                inquiry@veerelectrical.com
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Veer Electrical. All rights reserved.</p>
          <Link to="/admin/login" className="hover:text-amber-400" data-testid="footer-admin-link">
            Admin Portal
          </Link>
        </div>
      </div>
    </footer>
  );
}
